import { Injectable } from '@angular/core';
import { ActHttpService, ContentTypes, HeaderTypes } from '../act-http/act-http.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import { PINRequest, PublicKeyResponse, SetupPINRequest, SetupPINResponse, UserPINExistsResponse, VerifyPINRequest, VerifyPINResponse } from 'app/model/pin/pin.model';
import { EncryptService } from '../encrypt/encrypt.service';
import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class PinService {

  constructor(
    private actHttp: ActHttpService,
    private encrypt: EncryptService,
    private authenticationService: AuthenticationService,
  ) { }

  public getPublicKey(): Observable<PublicKeyResponse> {
    const url = `${environment.endpoint.publicKeyPIN}`;
    const options = this.authenticationService.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    return this.actHttp.get(url, options).map((res: Response) => res.json().data);
  }

  public setupPIN(rawPin: string, token:string, publicKey: string, verifiedToken?: string): Observable<SetupPINResponse> {
    const url = `${environment.endpoint.setupPIN}`;
    const options = this.authenticationService.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    const encryptPIN = this.getEncryptPINRequest(rawPin, token, publicKey)
    const setupPINRequest = new SetupPINRequest(encryptPIN, verifiedToken);
    return this.actHttp.post(url, setupPINRequest, options).map((res: Response) => new SetupPINResponse(res));
  }

  public verifyPIN(rawPin: string): Observable<VerifyPINResponse> {
    const url = `${environment.endpoint.verifyPIN}`;
    const options = this.authenticationService.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    return this.getPublicKey().flatMap((res: PublicKeyResponse) => {
      const encryptPIN = this.getEncryptPINRequest(rawPin, res.token, res.key);
      const verifyPINRequest = new VerifyPINRequest(encryptPIN);
      return this.actHttp.post(url, verifyPINRequest, options)
        .map((res: Response) => res.json().data);
    });
  }

  private getEncryptPINRequest(rawPin:string, token:string, publicKey:string):string {
    const pinRequest = new PINRequest(rawPin, token);
    const encryptPIN = this.encrypt.encryptWithPublicKey(JSON.stringify(pinRequest), publicKey)
    return encryptPIN;
  }

  public userPINExists(userId: number): Observable<UserPINExistsResponse> {
    const url = `${environment.endpoint.userPINExists}`.replace('{userId}', userId.toString());
    const option = this.authenticationService.getRequestOptions(HeaderTypes.ACT_TOKEN);
    return this.actHttp.get(url, option).map(m => m.json().data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pin/pin.service.ts